import axios from 'axios'
import { getItem, removeItem } from '@/helpers/persistanceStorage'
import apiConfig from '../config/config.json'
import router from '@/router'

axios.defaults.baseURL = apiConfig.apiHost

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'


// Добавляем токен в каждый запрос
axios.interceptors.request.use(
  config => {
    const token = getItem('accessToken')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)


// Обрабатываем ответы
axios.interceptors.response.use(
  response => {
    return response
  },

  error => {

    if (error.response && error.response.status === 401) {

      console.log('401 Unauthorized')

      // Удаляем старый токен
      removeItem('accessToken')

      // Перенаправляем на страницу авторизации
      if (router.currentRoute.path !== '/logout') {
        router.push('/logout')
      }
    }

    return Promise.reject(error)
  }
)

export default axios